module.exports = __webpack_public_path__ + "img/live-stream-dark.674642b3.svg";